import axios from 'axios'
import config from '../config/dev.json'
import Vue from 'vue'
import { refresh } from './auth.service.js'

let path = '/api/v1'
let url = config.host + path + '/secure/intent'
let urlUp = config.host + path + '/file'

import production from '../config/production.json'

if( process.env.NODE_ENV === 'production'){
  url = production.host + path +'/secure/intent'
}

export async function getIntentById(id){
  return new Promise((resolve, reject) => {
    axios.get(url +'/get/'+id).then((response) => {
      let intent = response.data.data
      resolve(intent)
    }).catch(err => {
      if(err.response.status === 401){
        refresh().then(() => {
          resolve(getIntentById(id))
        }).catch(err => reject(err))
      }
    })
  })
}

export async function getAllIntentsbyBot(id) {
  return new Promise((resolve, reject) => {
    axios.get(url+ '/bot/get/'+ id).then((response) => {
      let intents = response.data.data
      resolve(intents)
    }).catch(err => {
      if(err.response.status === 401){
        refresh().then(() => {
          resolve(getAllIntentsbyBot())
        }).catch(err => reject(err))
      }
    })
  })
}


export async function getAllIntentsPublic(){
  return new Promise((resolve, reject) => {
    axios.get(url + '/get/intentall/public').then((response) => {
      let intents = response.data.data
      resolve(intents)
    }).catch(err => {
      if(err.response.status === 401){
        refresh().then(() => {
          resolve(getAllIntentsPublic())
        }).catch(err => reject(err))
      }
    })
  })
}
export async function addIntentListPublic(intent) {
  console.log("servicce add public intent ", intent)
  return new Promise((resolve, reject) => {
    intent.intent.slug = intent.intent.name.toLowerCase()
    axios.post(url + '/add/public', intent).then((response) => {
      let intent = response.data.data
      resolve(intent)
    }).catch(err => reject(err))
  })
}
export async function addIntentPublic(intent) {
  return new Promise((resolve, reject) => {
    intent.slug = intent.name.toLowerCase()
    axios.post(url + '/publicintent/add', intent).then((response) => {
      let intent = response.data.data
      resolve(intent)
    }).catch(err => reject(err))
  })
}
export async function addIntent(intent) {
  return new Promise((resolve, reject) => {
    intent.slug = intent.name.toLowerCase()
    axios.post(url + '/add', intent).then((response) => {
      let intent = response.data.data
      resolve(intent)
    }).catch(err => reject(err))
  })
}

export async function updateIntent(intent){
  return new Promise((resolve, reject) => {
    axios.put(url + '/update/' + intent._id, intent).then((response) => {
      let upIntent = response.data.data
     
      resolve(upIntent)
    }).catch(err => {
      console.log('test err' , err.response.data)
     
       
    })
  })
}

export async function deleteIntent(intent) {
  return new Promise((resolve, reject) => {
    if (intent._id) {
      axios.delete(url + '/remove/' + id).then((response) => {
        resolve(response.data.data)
      }).catch(err => reject(err))
    } else {
      console.log(intent)
      intent.forEach(el => {
        axios.delete(url + '/remove/' + el._id).then((response) => {
          resolve(response.data.data)
        }).catch(err => reject(err))
      })
    }
  })
}

// upload nrmlm tkoun fi upload file // serviceuploadfile intent
export async function uploadFileExcel(formData, id, language){
  return new Promise((resolve, reject) => {
   
    axios.post(urlUp + '/upload/'+id+'/intents/'+language.isocode , formData,
    {
      headers: {
          'Content-Type': 'multipart/form-data'
      }
    }).then((response) => {
     
      console.log('tetst res', response.data.data)
    //  location.reload()
      
      
      let propsData = {
        direction: "right",
        duration: 1500
      }
      if (response.data.data==="files printed successfully"){
        Vue.prototype.$notif.show(
          (propsData = {
            
             title: "Success",
             message: response.data.data,
             type: "success"
          })
        );
      }else{
        console.log("response.data.data",response.data.data)
        Vue.prototype.$notif.show(
          (propsData = {
            title: "Error !",
            message:response.data.data ,
            type: "danger"
          })
        );
      }
     
    
          resolve(response.data.data)
    })
    .catch(err => {
      let propsData = {
        direction: "right",
        duration: 1500
      }
      console.log('test err' , err)
      Vue.prototype.$notif.show(
            (propsData = {
              title: "Error !",
              message: "Check your list intent Maybe this intent exist  !",
              type: "danger"
            })
          );
       
    })
  })
}

// export async function deleteSynonym(obj){
//   return new Promise((resolve, reject) => {
//     let id = obj._id
//     axios.delete(url + '/remove/' + id, obj).then((response) => {
//       let updateIntent = response.data.data
//       resolve(updateIntent)
//     }).catch(err => reject(err))
//   })
// }


// WEBPACK FOOTER //
// ./src/api/intent.service.js